import { getBackgroundColorForSide } from '@/utils/templateColor';
import { useTemplateStore } from '@/store/template.store';
import type { ITemplateConfigurationRepository } from '@/application/ports/ITemplateConfigurationRepository';
import type { TSide } from '@/domain/shared/TSide';

class PiniaTemplateConfigurationRepository implements ITemplateConfigurationRepository {
    getBackgroundColor(side: TSide): string {
        return getBackgroundColorForSide(useTemplateStore().selectedTemplate.configuration, side);
    }

    setBackgroundColor(side: TSide, color: string): void {
        useTemplateStore().setBackgroundColor(side, color);
    }
}

export { PiniaTemplateConfigurationRepository };
